import React, { useState } from "react";
import RegisterForm from "../User_info_handle/Register_form";
import UpdateForm from "../User_info_handle/Update_form";
import PaceRegister from "../User_info_handle/Pace_register";
import BlockUser from "../Block_user/Block_user";
import TabContent from "../ComponentV2/TabContent_register";
import TabNavItem from "../ComponentV2/TabNavItem_admin";

import "./user_render.css";

const User_render = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  return (
    <div className="tabs-user">
      {/* Tab nav */}
      <ul className="nav-user">
        <TabNavItem
          title="Registrar"
          id="tab1"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Modificar"
          id="tab2"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Registrar a Pace"
          id="tab3"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <TabNavItem
          title="Bloquear"
          id="tab4"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </ul>
      <div className="outlet-user">
        <TabContent id="tab1" activeTab={activeTab}>
          <RegisterForm />
        </TabContent>
        <TabContent id="tab2" activeTab={activeTab}>
          <UpdateForm />
        </TabContent>
        <TabContent id="tab3" activeTab={activeTab}>
          <PaceRegister />
        </TabContent>
        <TabContent id="tab4" activeTab={activeTab}>
          <BlockUser />
        </TabContent>
      </div>
    </div>
  );
};

export default User_render;
